import React from 'react';
import PropTypes from 'prop-types';
import { resolvedRoles } from '@hig/theme-data/build/esm/unresolved/lightGrayMediumDensityTheme';
import NegativeBanner from './negative-balance-banner';
import LowBalanceBanner from './low-balance-banner';

const warningColor = resolvedRoles["basics.colors.secondary.yellowOrange.500"];
const urgentColor = resolvedRoles["basics.colors.secondary.red.600"];
const normalColor = resolvedRoles["basics.colors.primary.autodeskBlue.500"];

// TODO: DEVX-8354 GracePeriod logic, we no longer know user's balance, do not need banner
const CloudCreditBanner = ({ cloudCredits, defaultThreshold, customThreshold }) => {
    try {

        const threshold = (customThreshold.length) ? parseInt(customThreshold[0].value) : parseInt(defaultThreshold.value);
        const thresholdTextColor = document.getElementById("remaining_cloud_credits");

        const thresholdTextColorHandler = (color) => {
            if (thresholdTextColor) thresholdTextColor.style.color = color;
        };

        const displayBanner = () => {
            if (cloudCredits < 0) {
                thresholdTextColorHandler(urgentColor);
                return  <NegativeBanner />;
            } else if (cloudCredits <= threshold) {
                thresholdTextColorHandler(warningColor);
                return <LowBalanceBanner />;
            } else {
                thresholdTextColorHandler(normalColor);
                return null;
            }
        };
        return displayBanner();

    } catch (error) {
        console.error(error);
        return null;
    }

};

CloudCreditBanner.propTypes = {
    customThreshold: PropTypes.arrayOf(PropTypes.object),
    defaultThreshold: PropTypes.object,
    cloudCredits: PropTypes.string,
};

export default CloudCreditBanner;
